import styled from '@emotion/styled';
import { fontWeights } from 'app/typography';
import ListItem from './ListItem';

export default styled(ListItem)`
  cursor: default;
  color: var(--color-font-placeholder);
  font-weight: ${fontWeights.bold};
  &:hover {
    background-color: unset; // Override ListItem hover style
  }
`;
